import { render, staticRenderFns } from "./PlayList.vue?vue&type=template&id=0037b613&scoped=true"
import script from "./PlayList.vue?vue&type=script&lang=js"
export * from "./PlayList.vue?vue&type=script&lang=js"
import style0 from "./PlayList.vue?vue&type=style&index=0&id=0037b613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0037b613",
  null
  
)

export default component.exports